<template>
    <div>
        <p>
            六六官方平台面向房产租赁行业合规从业者开放合作。包括职业经纪人与职业房东，以及房产经纪公司、代理经租企业、品牌公寓企业与物业管理公司等均可以申请，经审核与培训后成为六六官方合作伙伴。
        </p>
        <br>

        <h4 class='section-title'>合作要求</h4>
        <ol class='ol-list'>
            <li>发布真实房源信息，告知客户真实情况，节约客户时间。</li>
            <li>诚实守信经营，不欺骗不套路，保障客户权益。</li>
            <li>申请人无失信与犯罪记录。</li>
        </ol>

        <br>
        <h4 class='section-title'>合作流程</h4>
        <ol class='ol-list'>
            <li><span class='text text-info'>下载“六六合作伙伴”App</span>，提交申请</li>
            <!-- <li>添加工作人员微信（2816831652）获取审核进度</li> -->
            <li>参加培训，通过考试后签署合作协议</li>
        </ol>

        <!-- <p>
            如有疑问，请加市场工作人员微信号：<span class='text text-info'>2816831652</span>
        </p> -->
    </div>
</template>

<script>
    export default {
        data () {
            return {
                ifPro: window.location.host == 'clause.zuber.im'
            }
        },
        methods: {
            download () {
                if (this.ifPro) window.open('https://m.66zhizu.com/?type=agent')
                else window.open('http://beta.66zhizu.com/?type=agent')
            }
        }
    }
</script>


<style lang="less" scoped>
    .section-title {
        margin-bottom: 10px;
    }
    .ol-list {
        padding-left: 20px;
        li {
            margin-bottom: 5px;
        }
    }
</style>

